"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var patchIcon_1 = require("../../../utils/patchIcon");
function Button(props) {
    var open = props.open, onClick = props.onClick, tooltipId = props.tooltipId, icon = props.icon, buttonClassName = props.buttonClassName, title = props.title;
    var patchedIcon = patchIcon_1.default(icon, { className: 'ee_tooltip-icon__icon' });
    return (React.createElement("button", { type: "button", className: buttonClassName, onClick: onClick, "aria-haspopup": "true", "aria-expanded": open, "aria-describedby": tooltipId, title: title }, patchedIcon));
}
exports.default = Button;
//# sourceMappingURL=button.js.map
